export const feedbackTabs = () => {
  const tabElements = document.querySelectorAll(`.js-tab`);
  const feedbackFormElement = document.querySelector(`.js-form-feedback`);

  if (tabElements.length && feedbackFormElement) {
    const hiddenInputElement = feedbackFormElement.querySelector(`.js-h-input`);
    const submitButtonElement = feedbackFormElement.querySelector(`.js-button-text`);

    function updateFormHandler(event) {
      const self = event.currentTarget;
      const letterType = self.dataset.tabName;

      updateInputValue(letterType);
      updateButtonText(letterType);
      updateClassName(self);
    }

    function updateInputValue(type) {
      if (hiddenInputElement) {
        hiddenInputElement.value = type;
      }
    }

    function updateButtonText(type) {
      if (submitButtonElement) {
        switch (type) {
          case `cooperation`:
            submitButtonElement.textContent = `Отправить заявку`;
            break;
          case `director`:
            submitButtonElement.textContent = `Отправить письмо`;
            break;
          case `review`:
            submitButtonElement.textContent = `Отправить отзыв`;
            break;
          case `complaint`:
            submitButtonElement.textContent = `Отправить жалобу`;
            break;
          default:
            break;
        }
      }
    }

    function updateClassName(self) {
      tabElements.forEach((tab) => {
        tab.classList.remove(`form__button--active`);
      });

      self.classList.add(`form__button--active`);
    }

    tabElements.forEach((tab) => {
      tab.addEventListener(`click`, updateFormHandler);
    });
  }
};
